<div class="header fixed-top">
    <div class="container-fluid">
      <div class="row">
        <div class="headerSubDiv">
          <div class="headermainlogo">
            <a href="https://ftdcompanies.com/" target="_blank">
              <img src="assets/FTD_Logo_main.svg" alt="ftdindia Logo" loading="lazy" width="150" height="71">
            </a>
          </div>
          <div class="home-btn">
            <a href="." aria-label="Home Button">
              <i class="fa fa-home" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
</div>